import React from 'react';
import './CourseKind.css';

/* Standard / Mastery on a course card (student's classes: admin, teacher and student).
   kind comes from the API (CourseKind): 'standard' | 'mastery' (as set in Prices & Offers).
   Shown as a colored band down the left side of the card, with the word written vertically. */
export const KINDS = {
  standard: { label: 'Standard' },
  mastery: { label: 'Mastery' },
};

export const kindOf = (lessons) => {
  const k = (lessons || []).find((l) => l.CourseKind)?.CourseKind;
  return KINDS[k] ? k : null;
};

/* the card gets room on the left for the band */
export const kindCardClass = (kind) => (kind ? `rmck-card is-${kind}` : '');

const CourseKindTag = ({ kind }) => {
  const k = KINDS[kind];
  if (!k) return null;
  return (
    <span className={`rmck-band is-${kind}`} title={`${k.label} course`}>
      <span>{k.label}</span>
    </span>
  );
};

export default CourseKindTag;
